export default __webpack_public_path__ + "static/media/auth_graphic.b3849a6f.png";